/**
 * SaveNameDialog - Dialog for entering a save name
 */

import type { Component, ChangeEvent, KeyboardEvent } from 'react';

const React = (window as any).React;
const ReactComponent = React.Component;

interface SaveNameDialogProps {
    defaultValue: string;
    onSave: (name: string) => void;
    onCancel: () => void;
}

interface SaveNameDialogState {
    saveName: string;
}

class SaveNameDialog extends ReactComponent<SaveNameDialogProps, SaveNameDialogState> {
    private inputRef: HTMLInputElement | null = null;

    constructor(props: SaveNameDialogProps) {
        super(props);
        this.state = {
            saveName: props.defaultValue || ''
        };
    }

    componentDidMount(): void {
        // Auto-focus input
        setTimeout(() => {
            if (this.inputRef) {
                this.inputRef.focus();
                this.inputRef.select();
            }
        }, 0);
    }

    handleSave = (): void => {
        if (this.state.saveName.trim()) {
            this.props.onSave(this.state.saveName.trim());
        }
    };

    handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleSave();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            this.props.onCancel();
        }
    };

    render(): any {
        const DialogComponent = (window as any).Dialog;
        if (!DialogComponent) return null;

        return React.createElement(DialogComponent, {
            title: 'Save Game',
            onClose: this.props.onCancel,
            actionButtons: React.createElement(React.Fragment, null,
                React.createElement('button', {
                    className: 'btn',
                    onClick: this.props.onCancel
                }, 'Cancel'),
                React.createElement('button', {
                    className: 'btn',
                    onClick: this.handleSave,
                    disabled: !this.state.saveName.trim()
                }, 'Save')
            ),
            closeOnBackdropClick: false
        },
            React.createElement('div', { style: { padding: '20px' } },
                React.createElement('label', { 
                    style: { 
                        display: 'block', 
                        marginBottom: '8px', 
                        fontWeight: 'bold',
                        color: 'var(--main-text-color)'
                    } 
                }, 'Enter a name for the save:'),
                React.createElement('input', {
                    ref: (el: HTMLInputElement) => { this.inputRef = el; },
                    type: 'text',
                    value: this.state.saveName,
                    maxLength: 20,
                    onChange: (e: ChangeEvent<HTMLInputElement>) => {
                        this.setState({ saveName: e.target.value });
                    },
                    onKeyDown: this.handleKeyDown,
                    style: {
                        width: '100%',
                        padding: '8px',
                        fontFamily: 'var(--font-game-text)',
                        fontSize: '14px',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        borderRadius: '4px',
                        background: 'var(--main-bg-color)',
                        color: 'var(--main-text-color)'
                    }
                })
            )
        );
    }
}

(window as any).SaveNameDialog = SaveNameDialog;
export default SaveNameDialog;
